angular.module('zc.projects')

.directive 'zcLoginEvaluatorEditor', (ProjectLoginEvaluator, Meta, BaseProjectCrudEditor) ->

  class LoginEvaluatorEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.matchTypes = {}
      scope.evalutionTypes = {}

      Meta.getLoginEvaluatorEvaluationTypes().then (res) ->
        scope.evaluationTypes = res

      Meta.getLoginEvaluatorMatchTypes().then (res) ->
        scope.matchTypes = res

  editor = new LoginEvaluatorEditor(
    ProjectLoginEvaluator
    Meta
    '/templates/projects.settings/initialization/login_evaluator_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/login_evaluator_editor.directive.coffee